module.exports = __webpack_public_path__ + "static/media/mouton_02_thumb_hover.bc086f5c.png";